
    var riot = require('riot')
    import { SaytDivider } from './gb-sayt-divider';
riot.tag2('gb-sayt-divider', '<div if="{isVisible()}"></div>', 'gb-sayt-divider.gb-stylish > div,[data-is="gb-sayt-divider"].gb-stylish > div{ display: block; margin: 3px 10%; border-top: 1px solid #777; }', '', function(opts) {
    this._mixin(SaytDivider);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/sayt/gb-sayt-divider.tag.html